import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParameterCodec } from '@angular/common/http';
import { APP_SETTINGS } from '../models/backofficeConfiguration';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}


@Injectable()
export class UrlService {
  constructor(private http: HttpClient) { }

  GetInitialConfigurationData(): Promise<any> {
    let apibourl = window.location.origin + "/api/backoffice/config/getinitialconfiguration";
    const promise = this.http.get<any>(apibourl)
      .toPromise()
      .then(settings => {
        APP_SETTINGS.AuthorizationI3TokenUrl = settings['AuthorizationI3TokenUrl'];
        APP_SETTINGS.StaticContentRefresh = settings['StaticContentRefresh'];
        APP_SETTINGS.StaticContentUrl = settings['StaticContentUrl'];
        return settings;
      }).catch(() => alert("Error getting global configuration"));

    return promise;
  };

  GetConfigurationData(): Promise<any> {
    let apibourl = window.location.origin + "/api/backoffice/config/getconfiguration";
    const promise = this.http.get<any>(apibourl)
      .toPromise()
      .then(settings => {
        APP_SETTINGS.AuthorizationApiUrl = settings['AuthorizationApiUrl'];
        APP_SETTINGS.BackofficeApiUrl = settings['BackofficeApiUrl'];
        APP_SETTINGS.MasterDataApiUrl = settings['MasterDataApiUrl'];
        APP_SETTINGS.MarketToolI3ApiUrl = settings['MarketToolI3ApiUrl'];
        APP_SETTINGS.MarketToolBOApiUrl = settings['MarketToolBOApiUrl'];
        APP_SETTINGS.UsersApiUrl = settings['UsersApiUrl'];
        APP_SETTINGS.AuthorFollowApiUrl = settings['AuthorFollowApiUrl'];
        APP_SETTINGS.EventFollowApiUrl = settings['EventFollowApiUrl'];
        APP_SETTINGS.UserNewsletterApiUrl = settings['UserNewsletterApiUrl'];
        APP_SETTINGS.AuthorApiUrl = settings['AuthorApiUrl'];
        APP_SETTINGS.PostApiUrl = settings['PostApiUrl'];
        APP_SETTINGS.PostI3ApiUrl = settings['PostI3Url'];
        APP_SETTINGS.NewsletterTypesApiUrl = settings['NewsletterTypesApiUrl'];
        APP_SETTINGS.EditorialToolsApiUrl = settings['EditorialToolsApiUrl'];
        APP_SETTINGS.BrokersApiUrl = settings['BrokersApiUrl'];
        APP_SETTINGS.BasicUserSettingsApiUrl = settings['BasicUserSettingsApiUrl'];
        APP_SETTINGS.CalendarApiUrl = settings['CalendarApiUrl'];
        APP_SETTINGS.CalendarI3ApiUrl = settings['CalendarI3ApiUrl'];
        APP_SETTINGS.CalendarSettingsApiUrl = settings['CalendarSettingsApiUrl'];
        APP_SETTINGS.RatesTableSettingsApiUrl = settings['RatesTableSettingsApiUrl'];
        APP_SETTINGS.LeadApiUrl = settings['LeadApiUrl'];
        APP_SETTINGS.UserFunctionsApiUrl = settings['UserFunctionsApiUrl'];
        APP_SETTINGS.TagApiUrl = settings['TagApiUrl'];
        APP_SETTINGS.UserFunctionsApiKey = settings['UserFunctionsApiKey'];
        APP_SETTINGS.TranslationBOApiUrl = settings['TranslationBOApiUrl'];
        APP_SETTINGS.ConfigurationApiUrl = settings['ConfigurationApiUrl'];
        APP_SETTINGS.PaymentTransactionApiUrl = settings['PaymentTransactionApiUrl'];
        APP_SETTINGS.PostTranslationsConfig = settings['PostTranslationsConfig'];
        APP_SETTINGS.SignalsConfig = settings['SignalsConfig'];
        APP_SETTINGS.SignalBoConfig = settings['SignalBoConfig'];
        APP_SETTINGS.EmbedTweetEndpoint = settings['EmbedTweetEndpoint'];
        APP_SETTINGS.WebVitalsApiUrl = settings['WebVitalsApiUrl'];
        APP_SETTINGS.WebVitalsApiToken = settings['WebVitalsApiToken'];
        APP_SETTINGS.StorageApiUrl = settings['StorageApiUrl'];
        APP_SETTINGS.SupportedCultures = settings['SupportedCultures'];
        APP_SETTINGS.ScheduledApiUrl = settings['ScheduledApiUrl'];
        APP_SETTINGS.BOEnvironment = settings['BOEnvironment'];
        APP_SETTINGS.UserPayApiUrl = settings['UserPayApiUrl'];
        APP_SETTINGS.DeleteAccountApiUrl = settings['DeleteAccountApiUrl'];
        APP_SETTINGS.DiscordBotApiUrl = settings['DiscordBotApiUrl'];
        APP_SETTINGS.DiscordGetMemberByUserIdUrl = settings['DiscordMemberUrl'];

        return settings;
      }).catch(() => alert("Error getting initial configuration"));

    return promise;
  };

  public GetDashboardRoute(): string {
    return '/';
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/services/url.service.ts